import React, { useState, useEffect } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import {
  admin_event_booking_accept,
  interadmin_event_booking_accept,
  admin_event_booking_reject,
  interadmin_event_booking_reject,
  cfo_payment_accept,
  admin_event_booking_approve,
  admin_event_booking_submit,
  admin_event_booking_revert,
  admin_eventbooking_list,
  admin_event_view,
  admin_eventbooking_detail,
} from "../admin.api";
import "./dialog.css";
import Swal from "sweetalert2";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import { useParams } from "react-router-dom";
import moment from "moment";

const required = [
  "banner_location_text_ma",
  "notification_title_ma",
  "notification_desc_ma",
  "notification_desc_en",
];

export default function Dialog(props) {
  console.log(props);
  const servInstance = process.env.REACT_APP_BASE_URL;
  const result = servInstance.substring(0, servInstance?.length - 4);
  const [isActive, setIsActive] = useState([]);
  const eventParams = useParams();
  let adminTypes = Number(jwtDecode(props.state.payload).user_type);
  const [data, setData] = useState([]);
  const [url, setUrl] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [state, setState] = useState({
    open: props.open,
    data: props.data,
    adminType: props.adminType,
    edit: props.edit,
    submitted: false,
    snackMessage: "",
    isSnackError: false,
    snackOpen: false,
    data: props.data,
    isActive: false,
  });
  const handleEventList = () => {
    setIsActive(true);
    admin_eventbooking_detail(eventParams?.id).then((res) => {
      setData(res?.data[0]);
      setIsActive(false);
    });
  };

  useEffect(() => {
    handleEventList();
  }, [eventParams]);
  const handleDownload = (data) => {
    const path = `${result}${data}`;
    window.open(path, "_blank");
  };

  const { open, formData, adminType, edit } = state;
  const { view } = props;
  const handlePaymentConfirmation = (e) => {
    // const { formData } = this.state;

    const payload = {
      ...(data?.uuid ? { uuid: data?.uuid } : {}),
      ...(data?.bank_details ? { bank_details: data?.bank_details } : {}),
      ...(data?.reference_no ? { reference_no: data?.reference_no } : {}),
      ...(data?.transaction_date
        ? { transaction_date: data?.transaction_date }
        : {}),
      ...(data?.mode ? { mode: data?.mode } : {}),
      ...(data?.paid_amount ? { paid_amount: data?.paid_amount } : {}),
    };
    setIsActive(true);
    cfo_payment_accept(data?.uuid, payload)
      .then((res) => {
        // this.setState({
        //   open: false,
        //   submitted: true,
        //   snackMessage: res.message,
        //   isSnackError: false,
        //   snackOpen: true,
        // });
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        // this.setState({
        //   submitted: false,
        //   snackMessage: error.message,
        //   isSnackError: true,
        //   snackOpen: true,
        // });
        setSnackMessage(error?.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/event-booking");
    }
  };

  return (
    <>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <Loader open={isActive} />
      <div>
        <Loader open={isActive} />
        <div className="view-container ">
          <h6 className="d-flex align-items-center">
            <button
              style={{
                backgroundColor: "#0a223d",
                color: "#fff",
                border: "solid 1px #0a223d",
              }}
              type="button"
              className="btn btn-warning btn-sm  mr-2"
              onClick={(e) => {
                props.history.push("/event-booking/");
              }}
            >
              Back
            </button>
            <b>Event Registration Details</b>
          </h6>
          <hr />
          <div className="data">
            <>
              {(() => {
                const bookingDetails = data;

                return (
                  <>
                    <div className="row d-flex align-items-center">
                      <div className="col-3">Event Name</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.events?.event_title_en}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Venue</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.events?.location_en}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Participant Name</div>
                      <div className="col-1">:</div>
                      <div className="col-7">{bookingDetails?.full_name}</div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Address</div>
                      <div className="col-1">:</div>
                      <div className="col-7">{bookingDetails?.address}</div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Contact Number</div>
                      <div className="col-1">:</div>
                      <div className="col-7">{bookingDetails?.contact_no}</div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Email</div>
                      <div className="col-1">:</div>
                      <div className="col-7">{bookingDetails?.email}</div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Designation</div>
                      <div className="col-1">:</div>
                      <div className="col-7">{bookingDetails?.designation}</div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Event Registration Date</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.event_booking_date &&
                          moment(bookingDetails?.event_booking_date).format(
                            "DD-MM-YYYY"
                          )}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Booking Ref ID</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.booking_ref_id}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Registration Type</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.registration_type?.registration_type}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Number of Days</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.registration_type?.days}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Fees</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.registration_type?.fees}
                      </div>
                    </div>
                    <div className="row d-flex align-items-center">
                      <div className="col-3">Organizer</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.events?.oraganized_by_en}
                      </div>
                    </div>

                    <div className="row d-flex align-items-center">
                      <div className="col-3">Event Date</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {bookingDetails?.events?.event_date &&
                          moment(bookingDetails?.events?.event_date).format(
                            "DD-MM-YYYY"
                          )} &nbsp; to &nbsp;
                               {bookingDetails?.events?.event_date_to &&
                          moment(bookingDetails?.events?.event_date_to).format(
                            "DD-MM-YYYY"
                          )}
                      </div>
                    </div>

                    {(bookingDetails?.booking_status_text === "Payment Done" ||
                      bookingDetails?.payment_status === 1) && (
                      <>
                        <div className="row d-flex align-items-center">
                          <div className="col-3">Bank Details</div>
                          <div className="col-1">:</div>
                          <div className="col-7">
                            {bookingDetails?.bank_details}
                          </div>
                        </div>

                        <div className="row d-flex align-items-center">
                          <div className="col-3">Transaction ID</div>
                          <div className="col-1">:</div>
                          <div className="col-7">
                            {bookingDetails?.reference_no}
                          </div>
                        </div>


                        <div className="row d-flex align-items-center">
                          <div className="col-3">Unique Transaction Reference (UTR No.)</div>
                          <div className="col-1">:</div>
                          <div className="col-7">
                            {bookingDetails?.utr_no}
                          </div>
                        </div>

                        <div className="row d-flex align-items-center">
                          <div className="col-3">Transaction Date</div>
                          <div className="col-1">:</div>
                          <div className="col-7">
                            {bookingDetails?.transaction_date &&
                              moment(bookingDetails?.transaction_date).format(
                                "DD-MM-YYYY"
                              )}
                          </div>
                        </div>

                        <div className="row d-flex align-items-center">
                          <div className="col-3">Payment Mode</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{bookingDetails?.mode}</div>
                        </div>

                        <div className="row d-flex align-items-center">
                          <div className="col-3">Amount Paid</div>
                          <div className="col-1">:</div>
                          <div className="col-7">
                            {bookingDetails?.paid_amount}
                          </div>
                        </div>

                        {bookingDetails?.booking_status === "5" &&
                          bookingDetails?.super_admin_message && (
                            <div className="row d-flex align-items-center">
                              <div className="col-3">Revert Reason</div>
                              <div className="col-1">:</div>
                              <div className="col-7">
                                {bookingDetails?.super_admin_message}
                              </div>
                            </div>
                          )}

                        {bookingDetails?.admin_message && (
                          <div className="row d-flex align-items-center">
                            <div className="col-3">Admin Message</div>
                            <div className="col-1">:</div>
                            <div className="col-7">
                              {bookingDetails?.admin_message}
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {bookingDetails?.verification_document && (
                      <div className="row d-flex align-items-center">
                        <div className="col-3">Verification Document</div>
                        <div className="col-1">:</div>
                        <div className="col-7">
                          <button
                            type="button"
                            onClick={() =>
                              handleDownload(
                                bookingDetails?.verification_document
                              )
                            }
                            className="btn btn-document btn-dark"
                          >
                            Download Document
                          </button>
                        </div>
                      </div>
                    )}

                    {adminTypes === 23 && (
                      <div className="row mt-3 justify-content-center">
                        {bookingDetails?.booking_status == "1" && (
                          <button
                            type="button"
                            className="btn btn-success event-booking-buttons"
                            onClick={() => handlePaymentConfirmation()}
                          >
                            Final Acceptance with Payment Confirmation
                          </button>
                        )}

                        {bookingDetails?.booking_status == "0" && (
                          <button
                            type="button"
                            className="btn btn-danger event-booking-buttons"
                            onClick={() => handlePaymentConfirmation()}
                          >
                            Final Acceptance without Payment Confirmation
                          </button>
                        )}
                      </div>
                    )}
                  </>
                );
              })()}
            </>
          </div>
        </div>
      </div>
    </>
  );
}
